module.exports = __webpack_public_path__ + "img/proyecto_9.8a8707b9.png";